module.exports = __webpack_public_path__ + "static/media/ecrire-message-cercle.5b138c81.png";